<template>
  <div class="DesktopPage" @click="closeAllPopover">
    <!-- pc端用的侧边栏 -->
    <div
      v-if="isWideScreen"
      class="leftSideBar"
      :class="{ hide: !showLeftSideBar }"
    >
      <sideBar
        v-show="showLeftSideBar"
        @openPopover="openChatPopover"
        @openMoreChatPopover="openMoreChatPopover"
        @closeLeftSideBar="showLeftSideBar = false"
        @clickFindItem="clickFindItem"
        @clickHistoryChatItem="clickHistoryChatItem"
        @clickOpenNewChat="clickOpenNewChat"
        :isLogin="isLogin"
        :findList="findListForSideBar"
        :currentCount="currentCount"
        :totalCount="totalCount"
        :currentTokenCount="currentTokenCount"
        :totalTokenCount="totalTokenCount"
        :vipTotalCount="vipTotalCount"
        :moreChatList="moreChatList"
        :historyList="historyList"
        :currentChat="currentChat"
        :currentChat_conversation_id="currentChat_conversation_id"
        :isVip="isVip"
      ></sideBar>
    </div>
    <!-- 右侧内容 -->
    <div class="container">
      <!-- 标题栏 -->
      <div class="titleBarBox">
        <div class="left">
          <!-- 展开收起按钮 -->
          <div
            class="leftSideBarBox"
            @click="showLeftSideBar = true"
            v-show="!showLeftSideBar"
          >
            <img
              class="leftSideBarIcon"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/leftSideBarIcon.png"
              alt=""
            />
            <div class="popover">
              <smallPopover position="bottom" text="展开边栏"></smallPopover>
            </div>
          </div>

          <!-- 新对话 -->
          <div
            class="newChatTitleBox"
            v-if="(currentChat && currentChat.type == 'normal') || !currentChat"
          >
            {{
              currentChat && currentChat.name && currentChat.name != "新对话"
                ? currentChat.name
                : ""
            }}
          </div>

          <!-- 智能体信息 -->
          <div class="chatInfoBox" v-else @click="openChatDetailPopup">
            <img class="chatIcon" :src="currentChat.icon" alt="" />
            <div class="chatInfo" v-if="chatDetail">
              <div class="p1" v-if="currentChat">
                <div class="chatName">{{ currentChat.name }}</div>
                <div class="vipBox" v-if="currentChat.vipOnly == 1">
                  <span class="vipText">会员专属</span>
                </div>
              </div>
              <!-- 如果当前用户是会员  且智能体为会员专属-->
              <div class="p2">
                <span
                  class="gray"
                  v-if="calculateChatLimit.show && loginType == 1"
                  >{{ calculateChatLimit.text }}</span
                >
                <span
                  class="gray2"
                  v-if="calculateChatLimit.show && loginType == 1"
                  >｜</span
                ><span class="gray">内容由 AI 生成</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <!-- 登录信息 -->
          <div
            class="userInfo"
            v-if="isLogin && loginType == 1"
            @click.stop="openLoginPopover"
          >
            <img
              class="userAvatarIcon"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/userAvatarIcon.png"
              alt=""
            />
            <div class="userName">{{ inputPhoneNumber }}</div>
          </div>
          <!-- 未登录 -->
          <div class="loginBtn cursor" v-else @click="clickLoginBtn">登录</div>
        </div>
      </div>
      <!-- 对话内容 -->
      <div
        class="chatContentBox"
        :class="{ chatContent_generating: 1 == 1 }"
        ref="chatContentBox"
        @scroll="onChatContentScroll"
      >
        <div
          class="chatGuideBox"
          v-if="
            (currentChat &&
              currentChat.type == 'normal' &&
              !currentChat_conversation_id &&
              chatContent.length == 0) ||
            !currentChat
          "
        >
          <div class="guideTitle">你好，有什么我能帮你的吗？</div>
          <div class="guideList">
            <div class="guideItem" v-for="(value, key) in guideList" :key="key">
              <div class="itemTitle">
                <img class="icon" :src="value.icon" alt="" />
                <span class="name">{{ value.name }}</span>
              </div>
              <div class="itemList">
                <div
                  @click="clickGuideItem(value2)"
                  class="item"
                  v-for="(value2, key2) in value.guideList"
                  :key="key2"
                >
                  {{ value2.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chatContent" v-else>
          <div class="chatContent_list">
            <van-list
              v-model="chatContentLoading"
              :finished="!chatContentHasMore"
              finished-text=""
              @load="getHistoryMessageDetail"
              direction="up"
            >
              <div class="conversationContent" ref="conversationContent">
                <!-- 开场白 -->
                <div
                  class="assistant"
                  v-if="prologue && chatContentHasMore == false"
                >
                  <div
                    class="assistantTitle"
                    :class="{
                      cannotClick:
                        newChatInfo &&
                        currentChat_ai_app_code == newChatInfo.ai_app_code,
                    }"
                    @click="openChatDetailPopup"
                  >
                    <img
                      :src="currentChat.icon"
                      alt=""
                      class="assistantHeadIcon"
                    />
                    <div class="assistantName">
                      {{ currentChat.name }}
                    </div>
                    <img
                      v-show="
                        newChatInfo &&
                        currentChat_ai_app_code != newChatInfo.ai_app_code
                      "
                      class="right_arrow"
                      src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_black.png"
                      alt=""
                    />
                  </div>
                  <div class="assistantAnswerContent">
                    <div class="questionHintBox">
                      <div class="contentSummary">{{ prologue }}</div>
                      <div class="questionHintList">
                        <div
                          class="questionHintItem"
                          v-for="(value, key) in prologueList"
                          :key="key"
                          @click.stop="sendMessage(value)"
                        >
                          <div class="itemText">{{ value }}</div>
                          <img
                            class="right_arrow"
                            src="https://appflzt.oss-cn-shanghai.aliyuncs.com/static-h5/AI_H5/right_arrow_icon_gray.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 用户 机器人消息 -->
                <div
                  v-for="(value, key) in chatContent"
                  :key="value.id"
                  class="userAndAssistant"
                >
                  <!-- 用户提问 -->
                  <!-- 添加临时push后的文件预览 -->
                  <div
                    class="assistantContainer"
                    v-if="value.files && value.files.length > 0"
                  >
                    <div class="contentWrapper">
                      <filePreviewForPC
                        :dataHistoryConversation="value.files"
                        :aiAppCode="currentChat_ai_app_code"
                      >
                      </filePreviewForPC>
                    </div>
                  </div>
                  <!-- 历史会话拿到的文件预览 -->
                  <div
                    class="assistantContainer"
                    v-if="value.message_files && value.message_files.length > 0"
                  >
                    <div class="contentWrapper">
                      <filePreviewForPC
                        :dataHistoryConversation="value.message_files"
                        :aiAppCode="currentChat_ai_app_code"
                      >
                      </filePreviewForPC>
                    </div>
                  </div>
                  <div class="user" v-if="value.query">
                    <div class="userAnswerContent">
                      {{ value.query }}
                    </div>
                  </div>
                  <!-- 助手回答 -->
                  <div
                    class="assistant"
                    v-if="
                      !value.isBusiness &&
                      ((value.answer && value.answer != '') ||
                        (value.deepSeekAnswer && value.deepSeekAnswer != '') ||
                        (key == chatContent.length - 1 && isGenerating))
                    "
                  >
                    <div
                      class="assistantTitle"
                      :class="{
                        cannotClick:
                          newChatInfo &&
                          currentChat_ai_app_code == newChatInfo.ai_app_code,
                      }"
                      @click="openChatDetailPopup"
                    >
                      <img
                        :src="currentChat.icon"
                        alt=""
                        class="assistantHeadIcon"
                      />
                      <div class="assistantName">
                        {{ currentChat.name }}
                      </div>
                      <img
                        v-show="
                          newChatInfo &&
                          currentChat_ai_app_code != newChatInfo.ai_app_code
                        "
                        class="right_arrow"
                        src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/right_arrow_black.png"
                        alt=""
                      />
                    </div>
                    <div class="assistantAnswerContent">
                      <div
                        class="answerContent"
                        :id="'answerContent_' + value.id"
                      >
                        <div v-if="!value.isBusiness">
                          <!-- 思考中 -->
                          <div class="thinkingBox" v-if="value.isDeepSeek">
                            <!-- 思考顶部标签 -->
                            <div class="thinkingTitle">
                              <span class="span" v-if="!value.finishDeepSeek"
                                >思考中...</span
                              >
                              <span class="span" v-else>已深度思考</span>
                              <img
                                @click="foldThinkingContent(key)"
                                class="topArrow"
                                :class="{ topArrow_reverse: value.isFold }"
                                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/topArrowIcon_gray.png"
                                alt=""
                              />
                            </div>
                            <!-- 思考内容 -->
                            <div
                              class="thinkingContentBox"
                              v-show="!value.isFold"
                            >
                              <div class="leftLine"></div>
                              <div
                                class="thinkingContent"
                                v-html="markdownToHtml(value.deepSeekAnswer)"
                              ></div>
                            </div>
                          </div>
                          <!-- ceo 思考 -->
                          <div class="thinkingBox" v-if="value.isSpecialThink">
                            <!-- 思考顶部标签 -->
                            <div class="thinkingTitle">
                              <span
                                class="span"
                                v-if="!value.finishSpecialThink"
                                >思考中...</span
                              >
                              <span class="span" v-else>思考完成</span>
                              <img
                                @click="foldThinkingContent(key)"
                                class="topArrow"
                                :class="{ topArrow_reverse: value.isFold }"
                                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/topArrowIcon_gray.png"
                                alt=""
                              />
                            </div>
                            <!-- 思考内容 -->
                            <div
                              class="thinkingContentBox"
                              v-show="
                                !value.isFold && value.ceoAnimateArr.length > 0
                              "
                            >
                              <!-- ceo动画 -->
                              <div class="ceoAnimationBox">
                                <div
                                  class="ceoAnimationItem"
                                  v-for="(value2, key2) in value.ceoAnimateArr"
                                  :key="key2"
                                >
                                  <img
                                    class="icon icon_rotate"
                                    v-show="value2.status == 'loading'"
                                    src="@/assets/ceoLoading.png"
                                    alt=""
                                  />
                                  <img
                                    class="icon"
                                    v-show="value2.status == 'loadover'"
                                    src="@/assets/ceoLoadSuccess.png"
                                    alt=""
                                  />
                                  <div
                                    class="text"
                                    :class="{
                                      textAnimate: value2.status == 'loading',
                                    }"
                                  >
                                    <span>{{ value2.text }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- 正文回复 -->
                          <div
                            @click="clickMarkdown($event)"
                            :ref="'answerText' + key"
                            class="answerText"
                            v-html="markdownToHtml(value.answer)"
                          ></div>
                          <div
                            class="AI_generating_box"
                            v-if="key == chatContent.length - 1 && isGenerating"
                          >
                            <div class="AI_generating" id="AI_generating"></div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="answerOptions"
                        v-show="
                          (key != chatContent.length - 1 || !isGenerating) &&
                          !value.isBusiness &&
                          value.answer != '' &&
                          !value.isImage
                        "
                      >
                        <!-- 复制按钮 -->
                        <img
                          @click="clickCopyBtn(key)"
                          class="optionsIcon"
                          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/copyIcon_gray.png"
                          alt=""
                        />
                        <!-- 播放 取消播放  文字转语音 -->
                        <div class="playVoiceBox" v-if="!hideTTSBtn">
                          <!-- 播放按钮 -->
                          <img
                            class="optionsIcon"
                            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/playVoiceIcon.png"
                            alt=""
                            @click="clickPlayBtn(key)"
                            v-show="playingContentIndex != key"
                          />
                          <!-- 播放中 点击取消播放 -->
                          <img
                            class="optionsIcon"
                            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/playingVoiceIcon.png"
                            alt=""
                            @click="clickStopPlayBtn(key)"
                            v-show="playingContentIndex == key"
                          />
                        </div>
                      </div>
                      <div class="answerOptions" v-show="value.isImage">
                        <!-- 下载按钮 -->
                        <img
                          @click="downloadImage(value.answer)"
                          class="optionsIcon"
                          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/saveImageBtn_small.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 助手回答-业务 -->
                  <div
                    class="businessBox"
                    v-if="value.isBusiness && value.modal_card"
                  ></div>
                </div>
                <!-- 提示语 -->
                <div
                  class="suggestedBox"
                  v-if="suggestedData.length > 0 && !isGenerating"
                >
                  <div
                    class="suggestedItem"
                    v-for="(value, key) in suggestedData"
                    :key="key"
                    @click.stop="clickSuggested(value)"
                  >
                    {{ value }}
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </div>
      </div>
      <!-- 输入框 -->
      <div class="inputArea" :class="{ inputArea_generating: isGenerating }">
        <!-- 前往底部按钮 -->
        <transition name="fade">
          <div
            class="goToBottomBtn"
            @click="goToBottom"
            v-show="showGoToBottomBtn"
          >
            <img
              class="down_arrow_icon_black"
              src="@/assets/down_arrow_icon_black.png"
              alt=""
            />
            <img
              v-show="isGenerating"
              class="loading_blue_icon"
              src="@/assets/loading_blue_icon.png"
              alt=""
            />
          </div>
        </transition>
        <div class="inputBox" :class="{ inputBox_disabled: textAreaDisabled }">
          <div class="inputContent" @click="clickInputContent">
            <!-- 文件上传区域 -->
            <div
              class="uploadBox"
              v-show="filesWaitUpload && filesWaitUpload.length > 0"
            >
              <filePreviewForPC
                :receivedFileData="dataFromUpload"
                :aiAppCode="currentChat_ai_app_code"
                @sendFilesWaitUpload="sendFilesWaitUpload"
              >
              </filePreviewForPC>
            </div>
            <textarea
              :readonly="textAreaDisabled"
              ref="textarea"
              @input="textareaOnInput"
              @keydown.enter.exact.prevent="sendMessageByEnter"
              :placeholder="
                isTranslating ? '正在转换为文本…' : '有什么问题尽管问我'
              "
              class="textarea"
              :class="{ textarea_disabled: textAreaDisabled }"
              rows="1"
              v-model="inputContent"
              maxlength="999"
            ></textarea>
          </div>
          <!-- input下方的选项 -->
          <div class="inputOptionsBar">
            <div class="left">
              <!-- 上传文件按钮 -->
              <div
                class="inputOptionsDiv"
                v-show="
                  !isRecording &&
                  showFileUpload &&
                  maxUploadCnt > completeFiles.length &&
                  isLogin &&
                  (isVip || (chatDetail && chatDetail.vipOnly == 0))
                "
              >
                <uploadFileForPC @sendFilesData="sendFilesData">
                </uploadFileForPC>
                <div class="popover">
                  <smallPopover position="top" text="添加文件"></smallPopover>
                </div>
              </div>
              <!-- 上传文件按钮 禁用 -->
              <!-- <img
                v-show="isRecording"
                class="inputOptionsIcon inputOptionsIcon_disabled"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/inputOptions_uploadBtn_disabled.png"
                alt=""
              /> -->
              <!-- 开始录音按钮 -->
              <div
                class="inputOptionsDiv"
                v-show="
                  !isRecording &&
                  !isTranslating &&
                  !isGenerating &&
                  isLogin &&
                  (isVip || (chatDetail && chatDetail.vipOnly == 0))
                "
              >
                <img
                  @click="startRecord"
                  class="inputOptionsIcon"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/inputOptions_microphoneBtn.png"
                  alt=""
                />
                <div class="popover" :class="{ 'popover-mobile': isMobile }">
                  <smallPopover position="top" text="语音输入"></smallPopover>
                </div>
              </div>

              <!-- 录音中按钮 -->
              <div
                class="inputOptionsDiv"
                v-show="isRecording && !isGenerating"
                @click="stopRecord"
              >
                <!-- 音波容器 -->
                <div class="soundWaveBox">
                  <div
                    class="soundWaveItemBar"
                    v-for="(bar, index) in soundWaveBars"
                    :key="index"
                    :style="{ height: bar.height + 'px' }"
                  ></div>
                </div>
                <div class="popover" :class="{ 'popover-mobile': isMobile }">
                  <smallPopover
                    position="top"
                    :text="'停止语音输入' + `(${second}s)`"
                  ></smallPopover>
                </div>
              </div>
              <!-- 转换中  录音按钮——禁用 -->
              <img
                v-show="isTranslating || isGenerating || !isLogin"
                class="inputOptionsIcon inputOptionsIcon_disabled"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/inputOptions_microphoneBtn_disabled.png"
                alt=""
              />
            </div>
            <div class="right">
              <!-- 发送按钮 -->
              <img
                @click="sendMessage(inputContent)"
                v-show="
                  inputContent.length > 0 &&
                  !isRecording &&
                  !isTranslating &&
                  !isGenerating
                "
                class="inputOptionsIcon"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/inputOptions_sendMessageBtn.png"
                alt=""
              />
              <!-- 发送按钮 禁用状态 -->
              <img
                v-show="
                  (inputContent.length <= 0 || isRecording || isTranslating) &&
                  !isGenerating
                "
                class="inputOptionsIcon inputOptionsIcon_disabled"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/inputOptions_sendMessageBtn_disabled.png"
                alt=""
              />
              <!-- 停止生成按钮 -->
              <img
                @click="stopGenerating"
                v-show="isGenerating"
                class="inputOptionsIcon"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/inputOptions_stopBtn.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="inputArea_hintBox" v-if="inputBottomHintContent.type == 1">
          <span class="orange">今日会话额度已用完，请明日再试。</span>
        </div>
        <div class="inputArea_hintBox" v-if="inputBottomHintContent.type == 2">
          <span class="orange"
            >该智能体为会员专属智能体，开通会员后，可与专属智能体对话。</span
          >
          <span class="blue">去开通</span>
        </div>
        <div class="inputArea_hintBox" v-if="inputBottomHintContent.type == 3">
          <span class="orange">请填写“{{ inputBottomHintContent.text }}”</span>
        </div>
        <!-- 键盘遮挡 -->
        <div
          class="keyboard_mask"
          :style="{ height: visualViewportHeight_difference + 'px' }"
        ></div>
      </div>
    </div>
    <!-- 浮动按钮组 -->
    <div class="floatBtnGroup" v-if="isLogin">
      <div
        @click="clickSwitchAutoTTS"
        v-if="!hideTTSBtn"
        class="autoPlayVoiceIconBox"
      >
        <img
          v-if="isAutoPlayVoice"
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/autoPlayVoiceIcon_enable.png"
          alt=""
        />
        <img
          v-else
          class="icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v2/autoPlayVoiceIcon_disabled.png"
          alt=""
        />
      </div>
      <div
        class="centerLineBox"
        v-if="chatDetail && chatDetail.inputParam && !hideTTSBtn"
      >
        <div class="centerLine"></div>
      </div>
      <div
        v-if="chatDetail && chatDetail.inputParam"
        class="user_input_formBox"
        @click="showChatInputsDialog = true"
      >
        <img
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/user_inputs_icon.png"
          alt=""
          class="icon"
        />
      </div>
    </div>

    <!-- 对话气泡  置顶、取消置顶、举报、分享、编辑、删除 -->
    <chatPopover
      :isShow="showChatPopover"
      :options="chatPopoverOptions"
      :event="chatPopoverTriggerEvent"
      @clickSetTop="clickSetTop"
      @clickSetUntop="clickSetTop"
      @clickEdit="clickEdit"
      @clickShare="clickShare"
      @clickReport="clickReport"
      @clickDelete="clickDelete"
    ></chatPopover>
    <!-- 登录气泡 用户协议、退出登录 -->
    <loginPopover
      :isShow="showLoginPopover"
      :event="loginPopoverTriggerEvent"
      @clickServiceAgreement="clickServiceAgreement"
      @clickLogout="showLogoutDialog = true"
    ></loginPopover>
    <!-- 对话列表气泡 更多对话  列表   -->
    <moreChatPopover
      @clickChatItem="clickFindItem"
      :isShow="showMoreChatPopover"
      :list="moreChatList"
      :event="moreChatPopoverTriggerEvent"
    ></moreChatPopover>
    <!-- overlay 登录 -->
    <van-overlay :show="showLoginDialog" z-index="2100">
      <div class="wrapper" @click="showLoginDialog = false">
        <div class="loginDialog" @click.stop>
          <!-- 状态1  -->
          <div class="type1" v-show="loginDialogType == 1">
            <div class="titleBox">
              <div class="title">欢迎登录麦绿素</div>
              <div class="secondTitle">
                将使用手机号作为用户帐号完成登录/注册
              </div>
            </div>
            <div class="formBox">
              <input
                class="inputPhone"
                type="text"
                placeholder="请输入手机号"
                v-model="inputPhoneNumber"
              />
              <div
                @click="clickGetCaptcha"
                class="getCaptchaBtn"
                :class="{
                  getCaptchaBtn_disabled: inputPhoneNumber.length <= 0,
                }"
              >
                获取验证码
              </div>
              <div class="agreeAgreementBox">
                <img
                  v-show="!hasAgreeAgreement"
                  class="checkBox"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/chechBox_uncheck.png"
                  alt=""
                  @click="hasAgreeAgreement = true"
                />
                <img
                  v-show="hasAgreeAgreement"
                  class="checkBox"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/chechBox_checked.png"
                  alt=""
                  @click="hasAgreeAgreement = false"
                />
                <div class="text">
                  <span class="gray">已阅读并同意</span>
                  <span class="black cursor" @click="clickServiceAgreement"
                    >《服务协议》</span
                  >
                </div>
              </div>
            </div>
            <!-- 游客 hint -->
            <div class="visitorHint" v-if="guestChatLimit > 0">
              <div class="hintItem">
                · 游客每天限对话{{ guestChatLimit }}条；
              </div>
              <div class="hintItem">· 注册登录后可享更多对话条数。</div>
            </div>
          </div>
          <!-- 状态2 -->
          <div class="type2" v-show="loginDialogType == 2">
            <img
              @click="loginDialogType = 1"
              class="rightArrow_special"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/rightArrow_special.png"
              alt=""
            />
            <div class="titleBox">
              <div class="title1">验证码已发送至</div>
              <div class="title2">{{ maskPhone(inputPhoneNumber) }}</div>
            </div>
            <div class="inputsBox">
              <div
                class="inputItem"
                :class="{
                  inputItem_error: value.error,
                }"
                v-for="(value, key) in loginCaptchaArr"
                :key="key"
              >
                <div class="inputItem_text" v-if="value.value">
                  {{ value.value }}
                </div>
                <div class="inputItem_focus" v-if="value.focus"></div>
              </div>
              <!-- 真实的input -->
              <input
                v-model="loginCaptchaStr"
                type="numeric"
                class="realInput"
                @input="loginCaptchaOnInput"
                @focus="loginCaptchaOnFocus"
                @blur="loginCaptchaOnBlur"
                maxlength="4"
              />
            </div>
            <div class="countDown" v-if="loginCountDown >= 0">
              {{ loginCountDown }}s
            </div>
            <div @click="clickGetCaptcha" class="resendBtn cursor" v-else>
              重新发送
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- overlay 温馨提示 -->
    <van-overlay :show="showWarmHintDialog" z-index="2101">
      <div class="wrapper">
        <div class="warmHintDialog">
          <div class="title">温馨提示</div>
          <div class="text">
            <span>已阅读并同意麦绿素的 </span>
            <span class="black cursor" @click="clickServiceAgreement"
              >《服务协议》</span
            >
          </div>
          <div class="buttons">
            <div
              class="button1"
              @click="
                hasAgreeAgreement = true;
                showWarmHintDialog = false;
              "
            >
              同意
            </div>
            <div
              class="button2"
              @click="
                hasAgreeAgreement = false;
                showWarmHintDialog = false;
              "
            >
              不同意
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- overlay 会话参数 -->
    <van-overlay :show="showChatInputsDialog" z-index="2099">
      <div class="wrapper" @click="clickFormShadeBox">
        <div class="chatInputsDialog" @click.stop>
          <div class="title">会话参数设置</div>
          <div class="inputsFormBox">
            <div
              class="optionItem"
              v-for="(value, key) in user_input_form"
              :key="key"
            >
              <div class="optionTitleBox">
                <span class="optionTitle">{{ value.label }}</span>
                <span class="optionHint" v-if="value.required == false"
                  >可选</span
                >
              </div>
              <!-- 普通输入框 -->
              <div class="optionContent" v-if="value.type == 'text-input'">
                <input
                  v-model="value.value"
                  :maxlength="value.max_length"
                  :placeholder="value.label"
                  class="optionInput"
                  type="text"
                />
              </div>
              <!-- 段落输入框 -->
              <div class="optionContent" v-if="value.type == 'paragraph'">
                <textarea
                  v-model="value.value"
                  :maxlength="value.max_length"
                  :placeholder="value.placeholder || value.label"
                  class="optionTextarea"
                  rows="4"
                ></textarea>
              </div>
              <!-- 选择器 -->
              <div
                class="optionContent"
                v-if="value.type == 'select'"
                @click="onUserInputClickPicker(key)"
              >
                <div class="optionValue">{{ value.value }}</div>
                <img
                  class="down_arrow_icon_gray"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/down_arrow_icon_gray.png"
                  alt=""
                />
                <van-popup
                  class="input_picker_popup"
                  :close-on-click-overlay="false"
                  v-model="value.showPicker"
                  round
                  position="bottom"
                >
                  <van-picker
                    show-toolbar
                    :columns="value.options"
                    @cancel="onUserInputPickerCancel(key)"
                    @confirm="onUserInputPickerConfirm($event, key)"
                  />
                </van-popup>
              </div>
            </div>
          </div>
          <div class="startChatBtn" @click="clickFormShadeBox">开始对话</div>
        </div>
      </div>
    </van-overlay>
    <!-- popup 智能体详情 -->
    <van-popup v-model="showChatDetailPopup" position="right">
      <div class="chatDetailPopup" v-if="currentChat">
        <img
          class="closeBtn cursor"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/closeBtn.png"
          alt=""
          @click="showChatDetailPopup = false"
        />
        <div class="chatInfoBox">
          <img class="AI_head_icon" :src="currentChat.icon" alt="" />
          <div class="text_box">
            <div class="p1">{{ currentChat.name }}</div>
            <div class="p2">{{ currentChat.desction }}</div>
          </div>
        </div>
        <div class="buttonsBox">
          <!-- <div class="shareBtn" @click="clickShare_fromDetail">分享智能体</div> -->
          <div class="clearBtn" @click="showClearContextDialog = true">
            清除上下文
          </div>
          <div
            class="deleteBtn"
            @click="showDeleteChatDialog_fromDetail = true"
          >
            从对话列表删除
          </div>
        </div>
      </div>
    </van-popup>
    <!-- popup 侧边栏 浮动形态 -->
    <van-popup
      class="leftSideBar_float_box"
      v-model="showLeftSideBar"
      position="left"
      v-if="!isWideScreen"
    >
      <div
        class="leftSideBar leftSideBar_float"
        :class="{ hide: !showLeftSideBar }"
      >
        <sideBar
          v-show="showLeftSideBar"
          @openPopover="openChatPopover"
          @openMoreChatPopover="openMoreChatPopover"
          @closeLeftSideBar="showLeftSideBar = false"
          @clickFindItem="clickFindItem"
          @clickHistoryChatItem="clickHistoryChatItem"
          @clickOpenNewChat="clickOpenNewChat"
          :isLogin="isLogin"
          :findList="findListForSideBar"
          :currentCount="currentCount"
          :totalCount="totalCount"
          :currentTokenCount="currentTokenCount"
          :totalTokenCount="totalTokenCount"
          :vipTotalCount="vipTotalCount"
          :moreChatList="moreChatList"
          :historyList="historyList"
          :currentChat="currentChat"
          :currentChat_conversation_id="currentChat_conversation_id"
          :isVip="isVip"
        ></sideBar>
      </div>
    </van-popup>
    <!-- loading -->
    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
    <!-- 删除对话的dialog -->
    <pcDialog
      :show="showDeleteChatDialog"
      title="确定删除对话?"
      subtitle="删除后，聊天记录将不可恢复。"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="删除"
      cancelButtonText="取消"
      cancelButtonTextColor="#28282D"
      cancelButtonBgColor="#FFFFFF"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      cancelButtonBorderColor="#E5E7EB"
      confirmButtonTextColor="#FFFFFF"
      confirmButtonBgColor="#EF4444"
      confirmButtonHoverBgColor="#DC2626"
      confirmButtonActiveBgColor="#DC2626"
      confirmButtonBorderColor="#EF4444"
      @cancel="showDeleteChatDialog = false"
      @confirm="confirmDelete"
    ></pcDialog>
    <!-- 删除对话的dialog 从详情页触发 -->
    <pcDialog
      :show="showDeleteChatDialog_fromDetail"
      title="确定删除对话?"
      subtitle="删除后，聊天记录将不可恢复。"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="删除"
      cancelButtonText="取消"
      cancelButtonTextColor="#28282D"
      cancelButtonBgColor="#FFFFFF"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      cancelButtonBorderColor="#E5E7EB"
      confirmButtonTextColor="#FFFFFF"
      confirmButtonBgColor="#EF4444"
      confirmButtonHoverBgColor="#DC2626"
      confirmButtonActiveBgColor="#DC2626"
      confirmButtonBorderColor="#EF4444"
      @cancel="showDeleteChatDialog_fromDetail = false"
      @confirm="confirmDelete_fromDetail"
    ></pcDialog>
    <!-- 清除上下文的dialog -->
    <pcDialog
      :show="showClearContextDialog"
      title="确定清除上下文?"
      subtitle="清除后，聊天记录将不可恢复。"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="清除"
      cancelButtonText="取消"
      cancelButtonTextColor="#28282D"
      cancelButtonBgColor="#FFFFFF"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      cancelButtonBorderColor="#E5E7EB"
      confirmButtonTextColor="#FFFFFF"
      confirmButtonBgColor="#EF4444"
      confirmButtonHoverBgColor="#DC2626"
      confirmButtonActiveBgColor="#DC2626"
      confirmButtonBorderColor="#EF4444"
      @cancel="showClearContextDialog = false"
      @confirm="clearContext"
    ></pcDialog>
    <!-- 会话额度用完的dialog -->
    <pcDialog
      :show="showTokenCountDialog"
      title="今日会话额度已用完，请明日再试。"
      :showCancelButton="true"
      :showConfirmButton="false"
      cancelButtonText="我知道了"
      cancelButtonTextColor="#FFF"
      cancelButtonBgColor="#1F2937"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      cancelButtonBorderColor="#1F2937"
      @cancel="showTokenCountDialog = false"
    ></pcDialog>
    <!-- 会员专属智能体dialog -->
    <pcDialog
      :show="showVipOnlyDialog"
      title="该智能体为会员专属智能体"
      subtitle="开通会员后，可与专属智能体对话。"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="去开通"
      cancelButtonText="取消"
      cancelButtonTextColor="#28282D"
      cancelButtonBgColor="#FFFFFF"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      cancelButtonBorderColor="#E5E7EB"
      confirmButtonTextColor="#FFFFFF"
      confirmButtonBgColor="#1F2937"
      confirmButtonBorderColor="#1F2937"
      @cancel="showVipOnlyDialog = false"
    ></pcDialog>
    <!-- 修改对话名称的dialog -->
    <pcDialog
      :show="showEditChatNameDialog"
      title="对话名称"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="确定"
      cancelButtonText="取消"
      cancelButtonTextColor="#28282D"
      cancelButtonBgColor="#FFFFFF"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      cancelButtonBorderColor="#E5E7EB"
      confirmButtonTextColor="#FFFFFF"
      confirmButtonBgColor="#1F2937"
      confirmButtonBorderColor="#1F2937"
      @cancel="showEditChatNameDialog = false"
      @confirm="editChatName"
    >
      <!-- 使用命名插槽pcDialogBody插入内容 -->
      <template #pcDialogBody>
        <input
          v-model="editChatName_inputValue"
          type="text"
          class="editChatNameInput"
          placeholder="请输入对话名称"
          maxlength="20"
        />
      </template>
    </pcDialog>
    <!-- 举报 dialog -->
    <pcDialog
      :show="showReportDialog"
      title="举报"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="提交"
      :confirmButtonDisabled="
        currentReportType == null || reportContent.trim() == ''
      "
      cancelButtonText="取消"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      @cancel="showReportDialog = false"
      @confirm="confirmReport"
      width="480px"
    >
      <template #pcDialogBody>
        <div class="reportContent">
          <div class="reportTypeList">
            <div
              class="reportTypeItem"
              :class="{ reportTypeItem_active: currentReportType == value }"
              v-for="(value, key) in reportTypeList"
              :key="key"
              @click="clickReportType(value)"
            >
              {{ value }}
            </div>
          </div>
          <textarea
            v-model="reportContent"
            maxlength="200"
            class="reportContentInput"
            placeholder="我们想知道你举报的原因，你可以描述你遇到的问题。"
          ></textarea>
        </div>
      </template>
    </pcDialog>
    <!-- 退出登录dialog -->
    <pcDialog
      :show="showLogoutDialog"
      title="退出登录?"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="退出"
      cancelButtonText="取消"
      cancelButtonTextColor="#28282D"
      cancelButtonBgColor="#FFFFFF"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      cancelButtonBorderColor="#E5E7EB"
      confirmButtonTextColor="#FFFFFF"
      confirmButtonBgColor="#EF4444"
      confirmButtonHoverBgColor="#DC2626"
      confirmButtonActiveBgColor="#DC2626"
      confirmButtonBorderColor="#EF4444"
      @cancel="showLogoutDialog = false"
      @confirm="logout"
    ></pcDialog>
    <!-- 合并游客对话记录 dialog -->
    <pcDialog
      :show="showMergeGuestDialog"
      title="是否合并游客对话记录？"
      :showCancelButton="true"
      :showConfirmButton="true"
      confirmButtonText="合并"
      cancelButtonText="不合并"
      cancelButtonHoverBgColor="#f3f4f6"
      cancelButtonActiveBgColor="#f3f4f6"
      @cancel="confirmNotMergeGuest"
      @confirm="confirmMergeGuest"
      width="480px"
    >
      <template #pcDialogBody>
        <div class="mergeText">
          合并后，将展示您先前游客身份的对话记录。不合并则为您创建新用户，不展示游客对话记录
        </div>
      </template>
    </pcDialog>
  </div>
</template>

<script>
// 引入VUE组件
import sideBar from "@/components/sideBar/sideBar.vue";
import chatPopover from "@/components/chatPopover/chatPopover.vue";
import moreChatPopover from "@/components/moreChatPopover/moreChatPopover";
import smallPopover from "@/components/smallPopover/smallPopover";
import loginPopover from "@/components/loginPopover/loginPopover";
import pcDialog from "@/components/pcDialog/pcDialog";
import UploadFileForPC from "@/components/uploadFileForPC/uploadFileForPC.vue";
import filePreviewForPC from "@/components/filePreviewForPC/filePreviewForPC.vue";

// 引入方法
import createMethods from "./DesktopPage_methods";
// 引入数据
import { DesktopPage_data } from "./DesktopPage_data";

import { marked } from "marked";
const renderer = new marked.Renderer();
marked.setOptions({
  mangle: false, // 防止转义电子邮件地址（可选）
  headerIds: false, // 如果你也不想生成header id（可选）
  // 关键设置 ↓↓↓
  gfm: true, // 关闭 GitHub Flavored Markdown，从而禁用自动链接
});
renderer.image = function (href, title, text) {
  return `<img src="${href.href}" alt="${text}" class="autoWidth_image">`;
};

import lottie from "lottie-web";
import voicePLaying_pcJSON from "@/assets/voicePLaying_pc.json";

export default {
  // 将外部数据合并到组件实例
  mixins: [DesktopPage_data],
  components: {
    sideBar,
    chatPopover,
    moreChatPopover,
    smallPopover,
    loginPopover,
    pcDialog,
    UploadFileForPC,
    filePreviewForPC,
  },
  computed: {
    // 判断是否是移动设备
    isMobile: function () {
      return !this.isWideScreen;
    },
    // 判断今日是否还有额度
    isHasChatLimit: function () {
      if (!this.currentChat) {
        return false;
      }
      if (this.isVip) {
        return (
          this.vipTotalCount - this.currentCount > 0 &&
          this.totalTokenCount - this.currentTokenCount > 0
        );
      } else {
        return (
          this.totalCount - this.currentCount > 0 &&
          this.totalTokenCount - this.currentTokenCount > 0
        );
      }
    },
    calculateChatLimit: function () {
      // 渠道额度正常
      if (this.chatDetail && this.isHasChatLimit) {
        // 用户是会员    并且智能体的会员额度 没有额度限制
        if (this.isVip && this.chatDetail.vipChatLimit === null) {
          return {
            show: false,
          };
        }
        // 用户不是会员   并且智能体的普通额度 没有额度限制
        if (!this.isVip && this.chatDetail.chatLimit === null) {
          return {
            show: false,
          };
        }
        // 用户是会员 智能体是会员
        if (this.isVip && this.chatDetail.vipOnly == 1) {
          return {
            show: true,
            text: `会员额度 ${
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? this.chatDetail.vipChatLimit - this.chatDetail.usedCount
                : 0
            }/${this.chatDetail.vipChatLimit}`,
            color:
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? "normal"
                : "red",
          };
        }
        // 用户是会员 智能体不是会员
        if (this.isVip && this.chatDetail.vipOnly == 0) {
          return {
            show: true,
            text: `会员额度 ${
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? this.chatDetail.vipChatLimit - this.chatDetail.usedCount
                : 0
            }/${this.chatDetail.vipChatLimit}`,
            color:
              this.chatDetail.vipChatLimit - this.chatDetail.usedCount > 0
                ? "normal"
                : "red",
          };
        }
        // 用户不是会员 智能体是会员
        if (!this.isVip && this.chatDetail.vipOnly == 1) {
          return {
            show: true,
            text: "会员已过期",
            color: "normal",
          };
        }
        // 用户不是会员 智能体不是会员
        if (!this.isVip && this.chatDetail.vipOnly == 0) {
          return {
            show: true,
            text: `今日剩余 ${
              this.chatDetail.chatLimit - this.chatDetail.usedCount > 0
                ? this.chatDetail.chatLimit - this.chatDetail.usedCount
                : 0
            }/${this.chatDetail.chatLimit}`,
            color:
              this.chatDetail.chatLimit - this.chatDetail.usedCount > 0
                ? "normal"
                : "red",
          };
        }
      }
      // 渠道额度用完
      if (this.chatDetail && !this.isHasChatLimit) {
        return {
          show: true,
          text: "总额度已用完",
        };
      }
      // 未获取到渠道额度 或者未获取到智能体信息
      return {
        show: false,
      };
    },
    textAreaDisabled: function () {
      if (!this.isLogin) {
        return true;
      }
      if (!this.isVip && this.chatDetail && this.chatDetail.vipOnly == 1) {
        return true;
      }
      if (this.isTranslating) {
        return true;
      }
    },
    // 计算底部hint文字内容
    inputBottomHintContent: function () {
      if (!this.chatDetail) {
        return {
          type: -1,
        };
      }
      // 判断是不是会员专属
      if (!this.isVip && this.chatDetail && this.chatDetail.vipOnly == 1) {
        return {
          type: 2,
        };
      }
      // 判断还有没有总会话额度
      if (
        (this.isVip && this.currentCount >= this.vipTotalCount) ||
        (!this.isVip && this.currentCount >= this.totalCount)
      ) {
        return {
          type: 1,
        };
      }
      // 如果当前用户是会员 判断当前会话有没有额度
      if (
        this.isVip &&
        this.chatDetail.vipChatLimit != null &&
        this.chatDetail.vipChatLimit - this.chatDetail.usedCount <= 0
      ) {
        return {
          type: 1,
        };
      }
      // 如果当前用户不是会员 判断当前会话有没有额度
      if (
        !this.isVip &&
        this.chatDetail.chatLimit != null &&
        this.chatDetail.chatLimit - this.chatDetail.usedCount <= 0
      ) {
        return {
          type: 1,
        };
      }
      // 判断是否需要填写xxx
      if (this.chatDetail && this.chatDetail.inputParam == 1) {
        let label = "";
        for (let i of this.user_input_form) {
          if (i.required && !i.value) {
            label = i.label;
            break;
          }
        }
        if (label == "") {
          return {
            type: -1,
          };
        } else {
          return {
            type: 3,
            text: label,
          };
        }
      }
      return {
        type: -1,
      };
    },
  },
  created() {
    // 将外部方法合并到组件实例
    Object.assign(this, createMethods(this));
  },
  methods: {
    // 这个方法很奇怪  挪不出去
    // 将markdown转换为html
    markdownToHtml(markdown) {
      return marked.parse(markdown, { renderer });
    },
  },
  mounted: async function () {
    const MediaSource = window.ManagedMediaSource || window.MediaSource;
    if (!MediaSource) {
      this.hideTTSBtn = true;
    }
    document.addEventListener("wheel", this.stopAutoScroll);
    // 拦截a标签跳转
    this.interceptATag();
    document.title = "麦绿素";
    // 判断当前屏幕宽度是否是宽屏
    this.handleResize(); // 首次加载时判断
    this.createIntervalTimer();
    window.addEventListener("resize", this.handleResize);
    // 如果当前的clientType_AI不是pc
    if (window.localStorage.getItem("clientType_AI") != "pc") {
      window.localStorage.removeItem("sessionId");
      window.localStorage.removeItem("sessionId_AI");
      window.localStorage.removeItem("userId_AI");
    }
    window.localStorage.setItem("appId_AI", "lzpc");
    window.localStorage.setItem("clientType_AI", "pc");
    window.localStorage.setItem("channelCode_AI", "lzpc");
    document.addEventListener("visibilitychange", this.visibilitychange);
    // this.$nextTick(() => {
    //   lottie.loadAnimation({
    //     container: this.$refs["recordIngBox"], // the dom element that will contain the animation
    //     renderer: "svg",
    //     loop: true,
    //     autoplay: true,
    //     animationData: voicePLaying_pcJSON, // the path to the animation json
    //   });
    // });
    // 先查一下是不是需要游客模式
    await this.getSystemInfo();
    // 如果系统开启了游客模式
    if (this.systemOpenGuestMode == true) {
      // 如果当前存在userId和sessionId，则直接调用登录后需要调用的接口
      if (
        window.localStorage.getItem("userId_AI") &&
        window.localStorage.getItem("sessionId_AI")
      ) {
        this.loading = true;
        // 如果查到了sessionId 但是没查到loginType  代表这是一个老用户
        this.loginType = window.localStorage.getItem("loginType") || 1;
        this.isLogin =
          this.loginType == 1 || this.loginType == 2 ? true : false;
        if (this.isLogin) {
          if (this.loginType == 1) {
            let phone = window.localStorage.getItem("userPhoneNumber");
            this.inputPhoneNumber = phone ? phone.slice(-4) : "";
          }
          if (this.loginType == 2) {
            this.inputPhoneNumber = "";
          }
        }
        await this.loginAfter();
        this.loading = false;
      } else {
        this.loading = true;
        // 未登录 去获取游客的sessionId
        await this.guestLogin();
        await this.loginAfter();
        this.loading = false;
      }
    }
    // 否则 没有开启游客模式
    else {
      console.log("未开启游客模式");
      // 这里有个特殊逻辑 有可能localstorage中存在userId和sessionId 但是loginType是2 此时认为是未登录状态
      if (
        window.localStorage.getItem("userId_AI") &&
        window.localStorage.getItem("sessionId_AI")
      ) {
        console.log("缓存中存在userId和sessionId");
        // 要么缓存中不存在loginType  要么loginType是1  这代表着这是一个真实用户
        if (
          !window.localStorage.getItem("loginType") ||
          window.localStorage.getItem("loginType") == 1
        ) {
          this.loading = true;
          this.isLogin = true;
          this.loginType = 1;
          let phone = window.localStorage.getItem("userPhoneNumber");
          this.inputPhoneNumber = phone ? phone.slice(-4) : "";
          await this.loginAfter();
          this.loading = false;
        } else {
          console.log("游客模式");
          // 否则 这是一个游客
          this.loginType = 2;
          this.isLogin = false;
          this.loading = true;
          await this.getFindList();
          await this.getGuides();
          this.loading = false;
          this.showLoginDialog = true;
        }
      } else {
        this.isLogin = false;
        this.loading = true;
        await this.getFindList();
        await this.getGuides();
        this.loading = false;
        this.showLoginDialog = true;
      }
    }
  },
  destroyed: function () {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("visibilitychange", this.visibilitychange);
    // 尝试销毁登录定时器
    if (this.loginCountDownTimer) {
      clearInterval(this.loginCountDownTimer);
      this.loginCountDownTimer = null;
    }
    if (this.stopViewportMonitoring) {
      this.stopViewportMonitoring();
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./DesktopPage.scss";
</style>

<style scoped>
.input_picker_popup {
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 40vw; /* 需要指定宽度 */
  min-width: 320px;
}
</style>

<style lang="scss">
.answerText {
  display: inline;
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin: 12px 0;
    font-size: 14px;
    line-height: 1.5;
    background: #fff;
  }
  th,
  td {
    border: 1px solid #e2e8f0;
    padding: 8px 12px;
    text-align: left;
    vertical-align: top;
  }
  th {
    background: #f7f9fc;
    font-weight: 500;
    color: #1f2937;
  }
  tr:nth-child(2n) {
    background: #fafbff;
  }
  img {
    max-width: 100%;
    display: block;
    margin: 4px 0;
  }
}
.mergeText {
  color: var(--Tokens-Text-primary, #28282d);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
</style>
